import { render, staticRenderFns } from "./ProfitData.vue?vue&type=template&id=4d107dc1"
import script from "./ProfitData.vue?vue&type=script&lang=js"
export * from "./ProfitData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports